import {
  DefaultButton,
  Panel,
  PanelType,
  PrimaryButton,
  Spinner,
  SpinnerSize,
  TextField,
} from 'office-ui-fabric-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CreateCityAreaPanel = ({
  isOpen,
  onClose,
  cityAreaTitle,
  setCityAreaTitle,
  onConfirmCreateCityArea,
  isCreatingCityArea,
}) => {
  const { t: translator } = useTranslation();
  const onTextChange = (_, value) => setCityAreaTitle(value);

  return (
    <div>
      <Panel
        isOpen={isOpen}
        type={PanelType.medium}
        onDismiss={isCreatingCityArea || onClose}
        isLightDismiss={true}
        onOuterClick={() => {}}
        closeButtonAriaLabel={translator('ariaLabel.panelClose')}
      >
        <div>
          <div className="panel-content">
            <h3 className="panel-header">
              {translator('pages.adminCityAreas.addCityArea')}
            </h3>
            <TextField
              label={translator('pages.adminCityAreas.panelGuideText')}
              value={cityAreaTitle}
              onChange={onTextChange}
              placeholder={translator('pages.adminCityAreas.panelPlaceholder')}
            />
          </div>
          <div className="panel-buttons">
            {isCreatingCityArea && <Spinner size={SpinnerSize.large} />}
            <DefaultButton
              text={translator('global.cancel')}
              onClick={onClose}
              disabled={isCreatingCityArea}
            />
            <PrimaryButton
              text={translator('global.confirm')}
              onClick={onConfirmCreateCityArea}
              disabled={isCreatingCityArea}
            />
          </div>
        </div>
      </Panel>
    </div>
  );
};

export { CreateCityAreaPanel };
